export const stripTags = str => {
    if (typeof document === 'undefined') return str;

    const tmp = document.createElement('DIV');
    tmp.innerHTML = str;
    return tmp.textContent || tmp.innerText;
};
